module.exports = __webpack_public_path__ + "img/waist.fcde0a13.png";